import { FunctionType } from '../enums/function-type.enum';
import { IMonitorSettings } from '../interfaces/imonitor-settings.interface';
import { WallMonitor } from './monitor.type';

export class TransferInfo {
  public monitor: WallMonitor;
  public destinationType: FunctionType;
  public destinationId: number;
  public sourceType: FunctionType;
  public sourceId: number;
  public objectParams: IMonitorSettings;

  constructor(
    monitor: WallMonitor,
    sourceType: FunctionType,
    sourceId: number,
    destinationType: FunctionType,
    destination: number,
    objectParams: IMonitorSettings = null
  ) {
    this.monitor = monitor;
    this.sourceType = sourceType;
    this.sourceId = sourceId;
    this.destinationType = destinationType;
    this.destinationId = destination;
    this.objectParams = objectParams;
  }
}
